<template>
  <div class="simple-city-software-input-with-optional-heading">
    <h5 v-if="heading">{{ heading }}</h5>
    <textarea
      :class="
        error
          ? 'simple-city-software-input error'
          : 'simple-city-software-input'
      "
      :type="type ? type : 'text'"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="data"
      @blur="blur()"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: undefined,
    };
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(e) {
        this.value = e;
        this.$emit("scs-input", this.value);
      },
    },
  },
  methods: {
    blur() {
      this.$emit("scs-blur");
    },
  },
  created() {
    if (this.initialValue) {
      this.value = this.initialValue;
    }
  },
  components: {},
  // todo : create number input for better styling
  emits: ["scs-input", "scs-blur"],
  props: [
    "heading",
    "placeholder",
    "initialValue",
    "disabled",
    "type",
    "error",
  ],
};
</script>
<style scoped>
.simple-city-software-input-with-optional-heading {
  display: flex;
  width: fit-content;
  flex-direction: column;
  align-items: center;
  max-width: 300px;
}

h5 {
  margin: 10px;
  width: 90%;
  text-align: left;
}

textarea {
  border: 1px solid var(--secondaryColor);
  text-align: center;
  font-family: Raleway;
  padding: 10px 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

textarea:focus {
  outline: none;
  filter: drop-shadow(0 0 4px var(--secondaryColor));
}
.error {
  border: 1px solid red;
}
</style>
